import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type { IChangeNncoPayload } from '../types';
import {
  AFFILIATES_APPROVED_PERMISSIONS,
  AFFILIATES_LIST_QUERY_KEY,
  CHANGE_NNCO_API_URL,
  CHANGE_NNCO_MUTATION_KEY,
} from '../constants';

export default function useChangeNncoMutation(): IContextMutationResult<void, Error, IChangeNncoPayload> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, IChangeNncoPayload>({
    mutationKey: [CHANGE_NNCO_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<void>(
      CHANGE_NNCO_API_URL,
      payload,
      {
        permission: AFFILIATES_APPROVED_PERMISSIONS.CHANGE_NNCO_FOR_AFFILIATES,
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [AFFILIATES_LIST_QUERY_KEY] });
      displayPresetToast('edited');
    },
  });
}
